import React from 'react';
import { Search, Layers, Zap, TrendingUp, Shield } from 'lucide-react';

export const Method = () => {
  const steps = [
    {
      icon: <Search size={40} />,
      number: '01',
      title: 'Diagnose',
      description: 'Schwachstellen & Dysbalancen erkennen – wir finden heraus, wo dein Körper Unterstützung braucht.'
    },
    {
      icon: <Layers size={40} />,
      number: '02',
      title: 'Haltung neu aufbauen',
      description: 'Richtige Bewegungsmuster aktivieren und falsche Gewohnheiten korrigieren.'
    },
    {
      icon: <Zap size={40} />,
      number: '03',
      title: 'Stabilität & Kraft',
      description: 'Fundamentale Strukturen stärken – für einen widerstandsfähigen Körper.'
    },
    {
      icon: <TrendingUp size={40} />,
      number: '04',
      title: 'Integration',
      description: 'Übertragung in Alltag und Sport – damit die Veränderungen dauerhaft bleiben.'
    },
    {
      icon: <Shield size={40} />,
      number: '05',
      title: 'Kontrolle & Support',
      description: 'Regelmäßige Technikchecks und Anpassungen für optimale Ergebnisse.'
    }
  ];

  return (
    <section style={{
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-subtle)'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Wie die Methode funktioniert
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Ein strukturierter 5-Schritte-Prozess, der dich systematisch zu einem schmerzfreien, starken Körper führt.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 'var(--spacing-large)',
          marginTop: 'var(--spacing-xl)'
        }}>
          {steps.map((step, index) => (
            <div key={index} className="network-card" style={{
              position: 'relative',
              paddingTop: 'var(--spacing-xl)',
              cursor: 'default'
            }}>
              <div style={{
                position: 'absolute',
                top: 'var(--spacing-medium)',
                right: 'var(--spacing-medium)',
                fontSize: '3rem',
                fontWeight: 700,
                color: 'var(--bg-section)',
                lineHeight: 1
              }}>
                {step.number}
              </div>
              <div style={{
                color: 'var(--brand-dark)',
                marginBottom: 'var(--spacing-medium)'
              }}>
                {step.icon}
              </div>
              <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
                {step.title}
              </h3>
              <p className="body-medium">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};